import { Component, OnInit, NgZone } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components';
import { Router } from '@angular/router';
import { 
  FirebaseService,
  CapacitorService,
  IonicService,
  HttpService
} from '../../services';
import { LoginPage } from 'src/app/pages';

@Component({
  standalone: true,
  selector: 'page-index',
  templateUrl: './index.page.html',
  styleUrls: ['./index.page.scss'],
  imports: [
    IonicModule, CommonModule, ComponentsModule
  ],
})
export class IndexPage implements OnInit {
  
  data: any;
  language: string = '';
  spinner: boolean = false;
  native: boolean = false;

  //----------------------------------------------------------------------------
  // Constructor
  //----------------------------------------------------------------------------

  constructor(
    public firebase: FirebaseService,
    public modalHelp: ModalController,
    public capacitor: CapacitorService,
    public ionic: IonicService,
    public http: HttpService,
    public router: Router,
    public zone: NgZone
  ) { }

  //----------------------------------------------------------------------------
  // Initialize
  //----------------------------------------------------------------------------

  async ngOnInit() {
    this.firebase.setScreen('Index');
  }

  //----------------------------------------------------------------------------
  // Set Language
  //----------------------------------------------------------------------------

  async ionViewDidEnter() {
    this.native = await this.capacitor.isNative();
    let lang = this.ionic.getURL() != '' ? this.ionic.getURL() : 'en';
    this.language = await this.capacitor.getLanguage(lang);
    let title = this.capacitor.translateString('IndexHeading');
    let intro = this.capacitor.translateString('IndexIntro');
    this.firebase.setMeta(title, intro);
  }

  //----------------------------------------------------------------------------
  // Set Events
  //----------------------------------------------------------------------------

  async setEvents(event: string) {
    this.firebase.setEvent(event);
  }

  //----------------------------------------------------------------------------
  // Open Create
  //----------------------------------------------------------------------------

  async openCreate() {
    this.firebase.setEvent('login_create');
    this.firebase.setEvent('index_create');

    // Spinner
    this.showSpinner();

    // Request
    return await this.http.postRequest('/account', {
      language: this.capacitor.language,
      platform: this.capacitor.platform,
      push: this.capacitor.push

    }).then(async data => {
      if (data && data['token']) {
        await this.capacitor.setAuthorization(data['token']);
        this.router.navigateByUrl('/');
        window.location.reload();
      }
      return false;
    });
  }

  //----------------------------------------------------------------------------
  // Open Login
  //----------------------------------------------------------------------------

  async openLogin() {
    this.firebase.setEvent('index_login');
    this.ionic.openPage(LoginPage, 'login');
  }

  //----------------------------------------------------------------------------
  // Show Spinner
  //----------------------------------------------------------------------------

  async showSpinner() {
    this.spinner = true;
    setTimeout(() => { this.spinner = false; }, 5000);
  }

  //----------------------------------------------------------------------------
  // Close View
  //----------------------------------------------------------------------------

  async closePage() {
    const modal = await this.modalHelp.getTop();
    if (modal) {
      modal.setCurrentBreakpoint(0);
      await this.modalHelp.dismiss();
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
